/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  SettlementCompletedByTenantOptions,
  SettlementCompletedByTenantResponses,
} from '../types/SettlementCompletedByTenant'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Settle the guarantee for a tenant.
 * {@link /v1/tenants/:tenant_id/settlements/complete}
 */
export function settlementCompletedByTenant<ThrowOnError extends boolean = true>(
  options: Options<SettlementCompletedByTenantOptions, ThrowOnError>,
): Unwrappable<RequestResult<SettlementCompletedByTenantResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/tenants/{tenant_id}/settlements/complete',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<SettlementCompletedByTenantResponses, ThrowOnError>>,
  )
}
